<template>
  <v-container fluid class="px-0">
    <v-row align="baseline" class="mb-3">
      <v-col cols="12" md="12">
        <el-button
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="adresasTurtas()"
          >NT paieška pagal adresą</el-button
        >
        <el-button
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="registrasTurtas()"
          >NT paieška pagal registrą</el-button
        >
        <el-button
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="unikalusTurtas()"
          >NT paieška pagal unikalų numerį</el-button
        >
        <el-button
          v-if="showPasalintiTurta"
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="pasalintiTurtas()"
          >Pašalinti įkeltus NT</el-button
        >
      </v-col>
    </v-row>
    <v-row v-if="showFail" align="baseline" class="mb-0">
      <v-col cols="12">
        <v-alert dense outlined type="error">
          {{ failMsg }}
        </v-alert>
      </v-col>
    </v-row>

    <modal-ntr-turtas-pirmenybe-sarasas
      v-model="showTurtasSarasas"
      :is-adresas="turtasSarasasAdresas"
      :is-registras="turtasSarasasRegistras"
      @updateTurtasList="updateTurtasList"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import ModalNtrTurtasPirmenybeSarasas from '../modals/ModalNtrTurtasPirmenybeSarasas'

export default {
  name: 'RegPrasymasTurtasSearch',
  components: {
    ModalNtrTurtasPirmenybeSarasas,
  },
  mixins: [busena, tooltipNtr],
  props: {
    turtasTeise: { type: Boolean, default: false },
    turtasLength: { type: Number, default: 0 },
    pageloading: { type: Boolean, default: false },
  },
  data() {
    return {
      tur_identifikatorius: null,
      isSearching: false,
      loading: false,
      showFail: false,
      failMsg: null,
      search: null,
      itemsPerPageOptions: [10, 50],
      pageSize: 10,
      showTurtasSarasas: false,
      turtasSarasasAdresas: false,
      turtasSarasasRegistras: false,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    searchTurIdentifikatorius() {
      return (
        this.tur_identifikatorius ?? (this.isLocal ? '4193-9012-2010' : null)
      )
    },
    showPasalintiTurta() {
      return this.isPrasymasPirmenybe
    },

    yraTurtas() {
      return this.turtasLength > 0
    },
  },
  created() {
    //
  },
  methods: {
    pasalintiTurtas() {
      this.loading = true
      this.showFail = false

      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/turtas/pasalinti-ikeltus`
        )
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    adresasTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = true
      this.turtasSarasasRegistras = false
      this.showTurtasSarasas = true
    },
    registrasTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = false
      this.turtasSarasasRegistras = true
      this.showTurtasSarasas = true
    },
    unikalusTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = false
      this.turtasSarasasRegistras = false
      this.showTurtasSarasas = true
    },
    validateTurIdentifikatorius() {
      const unikalus = this.searchTurIdentifikatorius
        .replaceAll('-', '')
        .replaceAll(':', '')
      return unikalus.length == 12 || unikalus.length == 16
    },
    cancelSearch() {
      this.tur_identifikatorius = null
      this.showFail = false
      this.$emit('cancelSearch')
    },
    updateTurtasList(failMsg = null) {
      this.tur_identifikatorius = null
      if (failMsg) {
        this.failMsg = failMsg
        this.showFail = true
      }
      this.$emit('updateTurtasList')
    },
  },
}
</script>
<style lang="scss" scoped>
.teise-label {
  display: inline;

  p {
    margin: 0;
  }
  p.teise-bold {
    font-weight: 600;
  }
}
</style>
